import env from 'utils/env';
import request from './request';

export function createCategory(formData) {
  const requestUrl = `${env.aceApi}/1/categories`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
}
export const getAllCategories = () => request(`${env.aceApi}/1/categories/all`);

export const getCategoriesByCampaignId = (campaignId) =>
  request(`${env.aceApi}/1/categories/campaigns/${campaignId}`);

export const updateCategories = (campaignId, categories) => {
  const requestUrl = `${env.aceApi}/1/categories/campaigns/${campaignId}`;
  const data = JSON.stringify(categories);
  return request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
};
